import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

    mostrar = true;



  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  buscarTermino( termino:string ){
    this.router.navigate(['/buscar', termino]);
  }



}
